import { InternalNotesDatasource } from "@beneficiary/data/datasource/internal-notes.datasource";
import { CreateInternalNote } from "@beneficiary/domain/models/internal-notes/create-internal-note.model";
import { EditInternalNote } from "@beneficiary/domain/models/internal-notes/edit-internal-note.model";
import {
    InternalNote,
    InternalNotes,
} from "@beneficiary/domain/models/internal-notes/internal-note.model";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { ValidationError } from "@core/domain/errors/validation.error";
import { Pagination } from "@core/domain/models/pagination";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class InternalNotesRepository {
    constructor(
        @inject(InternalNotesDatasource)
        private readonly internalNotesDatasource: InternalNotesDatasource,
    ) {}

    async getAllBy(
        beneficiaryId: number,
        pagination: Pagination,
    ): Promise<Either<FallbackError, InternalNotes>> {
        return this.internalNotesDatasource.fetchAllBy(
            beneficiaryId,
            pagination,
        );
    }

    async create(
        internalNote: CreateInternalNote,
    ): Promise<Either<ValidationError | FallbackError, InternalNote>> {
        return this.internalNotesDatasource.create(internalNote);
    }

    async edit(
        editInternalNote: EditInternalNote,
    ): Promise<Either<ValidationError | FallbackError, InternalNote>> {
        return this.internalNotesDatasource.edit(editInternalNote);
    }

    async delete(
        internalNoteId: number,
    ): Promise<Either<FallbackError, boolean>> {
        return this.internalNotesDatasource.delete(internalNoteId);
    }
}
